import React, { Component } from 'react';

class Header extends Component {
  render() {
    return (
        <div className="w3-bar w3-black w3-large" style={{zIndex:'4'}}>
            <button className="w3-bar-item w3-button w3-hide-large w3-hover-none w3-hover-text-light-grey"><i className="fas fa-bars"></i> Menu</button>
            <span className="w3-bar-item w3-right">EbenLoveQuickPc</span>
        </div>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/Header/Header.js